module.exports = __webpack_public_path__ + "static/1-2fd73d5375d7086209d18c6dacfa9633.jpg";